import type { QueryHookOptions } from "@apollo/client";
import { gql, useQuery } from "@apollo/client";

import type { Taxonomy } from "@shared/types/graphqlGenerated";

const Taxonomies_Shared_Query = gql`
  query Taxonomies_Shared_Query(
    $levels: Int!
    $parentId: ID
    $topLevelName: String
    $storePlatform: String
    $allowSubtreeRoot: Boolean = false
  ) {
    viewer {
      taxonomies(
        levels: $levels
        parentId: $parentId
        topLevelName: $topLevelName
        storePlatform: $storePlatform
        allowSubtreeRoot: $allowSubtreeRoot
      ) {
        id
        depth
        name
        parentId
        children {
          id
          depth
          name
          parentId
          children {
            id
            depth
            name
            parentId
          }
        }
      }
    }
  }
`;

interface TaxonomiesData {
  viewer: {
    taxonomies: Taxonomy[];
  };
}

interface Variables {
  levels?: number;
  topLevelName?: string;
  parentId?: string;
  storePlatform?: string;
  allowSubtreeRoot?: boolean;
}

const useTaxonomiesQuery = (options?: QueryHookOptions<TaxonomiesData, Variables>) => {
  return useQuery<TaxonomiesData, Variables>(Taxonomies_Shared_Query, options);
};
export type { TaxonomiesData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useTaxonomiesQuery, Taxonomies_Shared_Query };
